import { render, staticRenderFns } from "./Index-Other.vue?vue&type=template&id=3da2e38a&"
import script from "./Index-Other.vue?vue&type=script&lang=js&"
export * from "./Index-Other.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports